/*@ngInject*/
const FileExportUtil = function (FileSaver, Blob) {

    this.saveAs = function (content, type, filename) {
        let file = new Blob([content], {type: type});

        FileSaver.saveAs(file, filename);
    };
};

angular.module('umCore')
    .service('fileExportUtil', FileExportUtil);
